import React, { useEffect, useRef, useState, useCallback } from "react";
import logo from "../assets/logo.png";

const SPORTS = [
  {
    id: "Badminton",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FbadmintonIcon2.png?alt=media&token=4fe902e9-6669-4d19-a99d-903c0488ec2e",
    team_limit: 2,
  },
  {
    id: "Basketball",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FbasketballIcon.png?alt=media&token=00a26e7b-94d4-445c-8bbc-c52c2a8d0704",
    team_limit: 3,
  },
  {
    id: "Boxing",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FboxingIcon.png?alt=media&token=75250c76-d2f2-4b91-b5c3-2bc826133590",
    team_limit: 0,
  },
  {
    id: "Fitness",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FfitnessIcon.png?alt=media&token=6db0578a-b07d-4c1d-9436-d83b66c5729d",
    team_limit: 0,
  },
  {
    id: "Football",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FfootballIcon.png?alt=media&token=c21a3a00-24e9-49af-968f-9fa6eebed784",
    team_limit: 5,
  },
  {
    id: "Padel",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FpadelIcon.png?alt=media&token=6a024474-a89c-49c8-855e-7b1cdd3a00b1",
    team_limit: 2,
  },
  {
    id: "Swimming",
    icon_url:
      "https://wcislnchclarifyudagt.supabase.co/storage/v1/object/public/images/sport-icons/swimming.png",
    team_limit: 0,
  },
  {
    id: "Tennis",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FtennisIcon.png?alt=media&token=9fc86c54-6055-43b9-ac38-7188430bbad5",
    team_limit: 2,
  },
  {
    id: "Track",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FtrackIcon.png?alt=media&token=7dbf3cdc-6c48-4d31-ac0b-0160cf135f53",
    team_limit: 0,
  },
  {
    id: "Volleyball",
    icon_url:
      "https://firebasestorage.googleapis.com/v0/b/snows-proam.appspot.com/o/sports%2Ficons%2FvolleyballIcon.png?alt=media&token=e9d93698-3ad8-4109-9359-72077b1d1d45",
    team_limit: 3,
  },
];

const CITIES = [
  "Casablanca",
  "Rabat",
  "Marrakech",
  "Fès",
  "Tangier",
  "Agadir",
  "Meknès",
  "Oujda",
  "Kenitra",
  "Tetouan",
  "Safi",
  "El Jadida",
  "Béni Mellal",
  "Settat",
  "Essaouira",
  "Ouarzazate",
  "Laâyoune",
  "Ifrane",
  "Dakhla",
  "Nador",
];

const LOGS = [
  { type: "scan", text: "Initialising Morocco sports index…" },
  { type: "ok", text: "Supabase connected · table: public.sports" },
  { type: "scan", text: "Loading sports from Supabase…" },
  { type: "add", text: "Badminton, Basketball, Boxing, Fitness loaded" },
  { type: "add", text: "Football, Padel, Swimming, Tennis loaded" },
  { type: "add", text: "Track, Volleyball loaded" },
  { type: "scan", text: "Applying Morocco-inspired visual layer…" },
  { type: "ok", text: "Zellige pattern + arch framing ready" },
  { type: "scan", text: "Querying Casablanca · radius 25 km" },
  { type: "ok", text: "34 venues found in Casablanca" },
  { type: "scan", text: "Querying Rabat · radius 20 km" },
  { type: "ok", text: "21 venues found in Rabat" },
  { type: "scan", text: "Querying Marrakech · radius 30 km" },
  { type: "ok", text: "29 venues found in Marrakech" },
  { type: "scan", text: "Querying Agadir · coastal and indoor venues" },
  { type: "ok", text: "23 venues found in Agadir" },
  { type: "scan", text: "Syncing sport metadata…" },
  { type: "add", text: "icon_url + team_limit mapped successfully" },
  { type: "ok", text: "✦ Morocco sports layer ready" },
];

const MoroccanStar = ({ size = 80, opacity = 0.16, color = "#0B6E4F", style = {} }) => {
  const s = size / 2;
  const points = [];
  for (let i = 0; i < 10; i++) {
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    const r = i % 2 === 0 ? s : s * 0.42;
    points.push(`${r * Math.cos(angle)},${r * Math.sin(angle)}`);
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox={`${-s} ${-s} ${size} ${size}`}
      style={{ opacity, ...style }}
    >
      <polygon
        points={points.join(" ")}
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const FloatingSport = ({ sport, radius, duration, delay }) => {
  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        marginLeft: -34,
        marginTop: -42,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
        animation: `orbit ${duration}s linear ${delay}s infinite`,
        "--r": `${radius}px`,
      }}
    >
      <div
        style={{
          width: 68,
          height: 68,
          borderRadius: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid rgba(255,255,255,0.10)",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.04) 100%)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.28)",
          overflow: "hidden",
          padding: 12,
        }}
      >
        <img
          src={sport.icon_url}
          alt={sport.id}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </div>

      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: "rgba(255,248,239,0.84)",
          letterSpacing: 0.2,
          whiteSpace: "nowrap",
        }}
      >
        {sport.id}
      </span>
    </div>
  );
};

function ArchFrame() {
  return (
    <svg
      viewBox="0 0 900 900"
      preserveAspectRatio="none"
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      <defs>
        <linearGradient id="archStroke" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.22)" />
          <stop offset="50%" stopColor="rgba(11,110,79,0.35)" />
          <stop offset="100%" stopColor="rgba(193,18,31,0.24)" />
        </linearGradient>
      </defs>

      <path
        d="M120 900 L120 360 Q450 40 780 360 L780 900"
        fill="none"
        stroke="url(#archStroke)"
        strokeWidth="2"
      />
      <path
        d="M170 900 L170 390 Q450 120 730 390 L730 900"
        fill="none"
        stroke="rgba(255,248,239,0.08)"
        strokeWidth="1.2"
      />
      <path
        d="M220 900 L220 420 Q450 185 680 420 L680 900"
        fill="none"
        stroke="rgba(193,18,31,0.12)"
        strokeWidth="1"
      />

      <line x1="110" y1="898" x2="790" y2="898" stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
      <line
        x1="140"
        y1="886"
        x2="760"
        y2="886"
        stroke="rgba(11,110,79,0.18)"
        strokeWidth="1"
        strokeDasharray="5 7"
      />
    </svg>
  );
}

export default function MoroccoScraper() {
  const [logs, setLogs] = useState([]);
  const [logIdx, setLogIdx] = useState(0);
  const [pct, setPct] = useState(0);
  const [cityStates, setCityStates] = useState({});
  const [stats, setStats] = useState({ locs: 0, sports: 0, cities: 0 });
  const [done, setDone] = useState(false);
  const termRef = useRef(null);
  const tickRef = useRef(null);

  const reset = useCallback(() => {
    setLogs([]);
    setLogIdx(0);
    setPct(0);
    setCityStates({});
    setStats({ locs: 0, sports: 0, cities: 0 });
    setDone(false);
  }, []);

  useEffect(() => {
    if (done) {
      const t = setTimeout(reset, 5000);
      return () => clearTimeout(t);
    }
  }, [done, reset]);

  useEffect(() => {
    if (done) return;

    const delay = 800 + Math.random() * 500;

    tickRef.current = setTimeout(() => {
      if (logIdx >= LOGS.length) {
        setDone(true);
        return;
      }

      const entry = LOGS[logIdx];
      const now = new Date();
      const ts = `${String(now.getHours()).padStart(2, "0")}:${String(
        now.getMinutes()
      ).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;

      const next = logIdx + 1;

      setLogs((prev) => [...prev, { ...entry, ts }]);
      setLogIdx(next);
      setPct(Math.round((next / LOGS.length) * 100));

      if (next % 3 === 0) {
        setCityStates((prev) => {
          const count = Math.min(Math.floor(next / 3), CITIES.length);
          const nextState = {};

          for (let i = 0; i < count; i++) {
            nextState[i] = i === count - 1 ? "active" : "done";
          }

          return nextState;
        });

        setStats({
          locs: Math.min(next * 14, 247),
          sports: Math.min(SPORTS.length, Math.max(1, Math.floor((next / LOGS.length) * SPORTS.length))),
          cities: Math.min(Math.floor(next / 3), 20),
        });
      }
    }, delay);

    return () => clearTimeout(tickRef.current);
  }, [logIdx, done]);

  useEffect(() => {
    if (termRef.current) {
      termRef.current.scrollTop = termRef.current.scrollHeight;
    }
  }, [logs]);

  useEffect(() => {
    if (done) {
      setCityStates(Object.fromEntries(CITIES.map((_, i) => [i, "done"])));
      setStats({ locs: 247, sports: SPORTS.length, cities: 20 });
      setPct(100);
    }
  }, [done]);

  const radii = [90, 140, 190, 240, 290];

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        background:
          "linear-gradient(135deg, #120808 0%, #1b0d0d 24%, #3d1118 52%, #0f3d31 100%)",
        fontFamily: "'DM Sans', sans-serif",
        color: "#fff8ef",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600;700&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes orbit {
          from { transform: rotate(0deg) translateX(var(--r)) rotate(0deg); }
          to   { transform: rotate(360deg) translateX(var(--r)) rotate(-360deg); }
        }

        @keyframes pulseDot {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.35; transform: scale(0.82); }
        }

        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }

        @keyframes scanline {
          0% { transform: translateY(-120%); }
          100% { transform: translateY(110vh); }
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }

        .zellige-bg {
          position: absolute;
          inset: 0;
          opacity: 0.14;
          background-image:
            linear-gradient(30deg, rgba(255,248,239,0.055) 12%, transparent 12.5%, transparent 87%, rgba(255,248,239,0.055) 87.5%, rgba(255,248,239,0.055)),
            linear-gradient(150deg, rgba(255,248,239,0.055) 12%, transparent 12.5%, transparent 87%, rgba(255,248,239,0.055) 87.5%, rgba(255,248,239,0.055)),
            linear-gradient(90deg, rgba(11,110,79,0.11) 2px, transparent 2px),
            linear-gradient(rgba(193,18,31,0.08) 2px, transparent 2px);
          background-size: 86px 86px, 86px 86px, 28px 28px, 28px 28px;
          background-position: 0 0, 0 0, 0 0, 0 0;
        }

        .scanline {
          position: absolute;
          left: 0;
          right: 0;
          height: 180px;
          background: linear-gradient(180deg, transparent 0%, rgba(255,255,255,0.06) 50%, transparent 100%);
          animation: scanline 9s linear infinite;
          mix-blend-mode: screen;
        }

        .glass {
          background: linear-gradient(180deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0.04) 100%);
          border: 1px solid rgba(255,255,255,0.10);
          box-shadow: 0 18px 60px rgba(0,0,0,0.24);
          backdrop-filter: blur(16px);
        }

        .city-chip {
          padding: 10px 12px;
          border-radius: 14px;
          font-size: 12px;
          font-weight: 600;
          text-align: center;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.07);
          color: rgba(255,248,239,0.55);
          transition: all 0.35s ease;
        }

        .city-chip.active {
          background: rgba(11,110,79,0.18);
          border-color: rgba(11,110,79,0.55);
          color: #e8fff7;
          box-shadow: 0 0 22px rgba(11,110,79,0.18);
        }

        .city-chip.done {
          background: rgba(193,18,31,0.10);
          border-color: rgba(193,18,31,0.18);
          color: rgba(255,216,216,0.82);
        }

        .log-line {
          display: flex;
          gap: 10px;
          align-items: baseline;
          line-height: 1.75;
          animation: fadeInUp 0.28s ease;
        }

        .blink-cursor {
          display: inline-block;
          width: 8px;
          height: 14px;
          background: #0B6E4F;
          border-radius: 2px;
          margin-left: 3px;
          animation: blink 0.85s step-end infinite;
          vertical-align: middle;
        }

        ::-webkit-scrollbar { width: 5px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb {
          background: rgba(255,255,255,0.18);
          border-radius: 999px;
        }

        @media (max-width: 980px) {
          .hero-grid {
            grid-template-columns: 1fr !important;
          }

          .left-copy {
            padding-right: 0 !important;
          }

          .visual-shell {
            min-height: 520px !important;
          }
        }

        @media (max-width: 640px) {
          .page-pad {
            padding: 18px !important;
          }

          .headline {
            font-size: clamp(34px, 10vw, 56px) !important;
          }

          .city-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .stats-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>

      <div className="zellige-bg" />
      <ArchFrame />

      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 15% 20%, rgba(193,18,31,0.18) 0%, transparent 28%), radial-gradient(circle at 85% 18%, rgba(11,110,79,0.18) 0%, transparent 24%), radial-gradient(circle at 50% 80%, rgba(255,248,239,0.08) 0%, transparent 30%)",
        }}
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <div className="scanline" />
      </div>

      <MoroccanStar size={140} color="#0B6E4F" opacity={0.22} style={{ position: "absolute", top: 28, left: 34 }} />
      <MoroccanStar size={96} color="#C1121F" opacity={0.18} style={{ position: "absolute", top: 86, right: 84 }} />
      <MoroccanStar size={72} color="#fff8ef" opacity={0.12} style={{ position: "absolute", bottom: 84, left: 74 }} />
      <MoroccanStar size={116} color="#0B6E4F" opacity={0.14} style={{ position: "absolute", bottom: 28, right: 34 }} />

      <div
        className="page-pad"
        style={{
          position: "relative",
          zIndex: 4,
          minHeight: "100vh",
          width: "100%",
          padding: 28,
          display: "flex",
          alignItems: "stretch",
        }}
      >
        <div
          className="hero-grid"
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1.05fr 0.95fr",
            gap: 24,
            alignItems: "stretch",
          }}
        >
          <div
            className="glass left-copy"
            style={{
              borderRadius: 30,
              padding: "28px clamp(22px, 3vw, 40px)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "calc(100vh - 56px)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.05) 0%, transparent 38%, rgba(11,110,79,0.04) 100%)",
                pointerEvents: "none",
              }}
            />

            <div style={{ position: "relative", zIndex: 2 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 14,
                  flexWrap: "wrap",
                  marginBottom: 34,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: 18,
                      background: "rgba(255,255,255,0.08)",
                      border: "1px solid rgba(255,255,255,0.10)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                      boxShadow: "0 10px 24px rgba(0,0,0,0.16)",
                    }}
                  >
                    <img
                      src={logo}
                      alt="Snows ProAm logo"
                      style={{
                        width: "78%",
                        height: "78%",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </div>

                  <div>
                    <div
                      style={{
                        fontFamily: "'Sora', sans-serif",
                        fontWeight: 700,
                        fontSize: 18,
                        color: "#fff8ef",
                        letterSpacing: -0.3,
                      }}
                    >
                      Snows ProAm
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "rgba(255,248,239,0.62)",
                        letterSpacing: 0.5,
                      }}
                    >
                      Sports Matchmaking • المغرب
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "8px 14px",
                    borderRadius: 999,
                    background: "rgba(11,110,79,0.16)",
                    border: "1px solid rgba(11,110,79,0.42)",
                    color: "#d7fff2",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: 0.8,
                    textTransform: "uppercase",
                  }}
                >
                  <div
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "#0B6E4F",
                      animation: "pulseDot 1.2s ease infinite",
                    }}
                  />
                  Live indexing
                </div>
              </div>

              <div style={{ marginBottom: 28 }}>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    borderRadius: 999,
                    padding: "7px 12px",
                    marginBottom: 16,
                    background: "rgba(255,248,239,0.08)",
                    border: "1px solid rgba(255,248,239,0.10)",
                    color: "rgba(255,248,239,0.85)",
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  Real sports from public.sports
                </div>

                <h1
                  className="headline"
                  style={{
                    fontFamily: "'Sora', sans-serif",
                    fontWeight: 800,
                    fontSize: "clamp(48px, 6vw, 88px)",
                    lineHeight: 0.95,
                    letterSpacing: -2.5,
                    color: "#fff8ef",
                    maxWidth: 820,
                    marginBottom: 18,
                  }}
                >
                  Morocco,
                  <br />
                  <span
                    style={{
                      background:
                        "linear-gradient(90deg, #fff8ef 0%, #0B6E4F 35%, #C1121F 68%, #fff8ef 100%)",
                      backgroundSize: "220% auto",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      animation: "shimmer 5s linear infinite",
                    }}
                  >
                    shaped by real sport data
                  </span>
                </h1>

                <p
                  style={{
                    fontSize: "clamp(15px, 1.4vw, 18px)",
                    lineHeight: 1.75,
                    color: "rgba(255,248,239,0.76)",
                    maxWidth: 760,
                  }}
                >
                Scanning the Moroccan map in real time, identifying courts, pitches, and sporting facilities...
                </p>
              </div>

              <div
                className="stats-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                  gap: 12,
                  marginBottom: 22,
                }}
              >
                {[
                  { val: stats.locs, label: "Locations found" },
                  { val: stats.sports, label: "Sports loaded" },
                  { val: stats.cities, label: "Cities scanned" },
                ].map((item) => (
                  <div
                    key={item.label}
                    style={{
                      borderRadius: 20,
                      padding: "18px 16px",
                      background:
                        "linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.04) 100%)",
                      border: "1px solid rgba(255,255,255,0.10)",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: "'Sora', sans-serif",
                        fontWeight: 800,
                        fontSize: 28,
                        color: "#fff8ef",
                        marginBottom: 4,
                      }}
                    >
                      {item.val}
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "rgba(255,248,239,0.58)",
                        letterSpacing: 0.25,
                      }}
                    >
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: 12,
                }}
              >
                {[
                  "الرياضة في كل مدينة",
                  "Sport grounded in your DB",
                  "Atlas • Atlantic • Sahara",
                  `${SPORTS.length} sports loaded`,
                ].map((line) => (
                  <div
                    key={line}
                    style={{
                      borderRadius: 16,
                      padding: "14px 16px",
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      color: "rgba(255,248,239,0.78)",
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    {line}
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{
                position: "relative",
                zIndex: 2,
                marginTop: 26,
                display: "flex",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              {SPORTS.slice(0, 5).map((sport) => (
                <div
                  key={sport.id}
                  style={{
                    padding: "10px 14px",
                    borderRadius: 999,
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    color: "rgba(255,248,239,0.82)",
                    fontSize: 12,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <img
                    src={sport.icon_url}
                    alt={sport.id}
                    style={{ width: 16, height: 16, objectFit: "contain" }}
                  />
                  {sport.id}
                </div>
              ))}
            </div>
          </div>

          <div
            className="glass visual-shell"
            style={{
              borderRadius: 30,
              padding: 20,
              position: "relative",
              minHeight: "calc(100vh - 56px)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "radial-gradient(circle at 50% 45%, rgba(255,255,255,0.10) 0%, transparent 20%), radial-gradient(circle at 50% 50%, rgba(11,110,79,0.16) 0%, transparent 32%), radial-gradient(circle at 50% 52%, rgba(193,18,31,0.18) 0%, transparent 48%)",
                pointerEvents: "none",
              }}
            />

            <div
              style={{
                position: "absolute",
                inset: 0,
                pointerEvents: "none",
                zIndex: 1,
              }}
            >
              {SPORTS.map((sport, i) => {
                const r = radii[i % radii.length] + (i % 2 === 0 ? 0 : 18);
                const dur = 16 + (i % 5) * 3;
                const delay = -(i * (dur / SPORTS.length));
                return (
                  <FloatingSport
                    key={sport.id}
                    sport={sport}
                    radius={r}
                    duration={dur}
                    delay={delay}
                  />
                );
              })}
            </div>

            <div
              style={{
                position: "absolute",
                left: "50%",
                top: "42%",
                transform: "translate(-50%, -50%)",
                width: "min(76%, 520px)",
                aspectRatio: "1 / 1",
                borderRadius: "50%",
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow:
                  "inset 0 0 0 1px rgba(255,255,255,0.04), 0 0 80px rgba(11,110,79,0.12)",
                pointerEvents: "none",
                zIndex: 2,
              }}
            >
              <MoroccanStar
                size={160}
                color="#0B6E4F"
                opacity={0.42}
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            </div>

            <div
              style={{
                position: "relative",
                zIndex: 5,
                marginTop: "auto",
                display: "grid",
                gap: 16,
              }}
            >
              <div
                style={{
                  borderRadius: 22,
                  overflow: "hidden",
                  background: "rgba(8,8,8,0.48)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  backdropFilter: "blur(14px)",
                }}
              >
                <div
                  style={{
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                    background: "rgba(255,255,255,0.04)",
                  }}
                >
                  {["#e85959", "#e8a84e", "#5cb85c"].map((c) => (
                    <div
                      key={c}
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: c,
                      }}
                    />
                  ))}
                  <span
                    style={{
                      marginLeft: 6,
                      fontSize: 11,
                      letterSpacing: 0.45,
                      color: "rgba(255,248,239,0.44)",
                    }}
                  >
                    snows-proam · live-indexing
                  </span>
                </div>

                <div
                  ref={termRef}
                  style={{
                    padding: "16px 16px 14px",
                    fontFamily: "'Courier New', monospace",
                    fontSize: 12,
                    color: "rgba(255,248,239,0.72)",
                    lineHeight: 1.85,
                    minHeight: 170,
                    maxHeight: 210,
                    overflowY: "auto",
                  }}
                >
                  {logs.map((l, i) => (
                    <div key={i} className="log-line">
                      <span
                        style={{
                          color: "rgba(255,248,239,0.35)",
                          fontSize: 10,
                          flexShrink: 0,
                        }}
                      >
                        {l.ts}
                      </span>
                      <span
                        style={{
                          color:
                            l.type === "ok"
                              ? "#84e0b7"
                              : l.type === "add"
                              ? "#f3b562"
                              : "#7eaaff",
                          flexShrink: 0,
                        }}
                      >
                        {l.type === "ok" ? "✓" : l.type === "add" ? "+" : "→"}
                      </span>
                      <span>{l.text}</span>
                    </div>
                  ))}
                  {!done && <span className="blink-cursor" />}
                </div>
              </div>

              <div
                style={{
                  borderRadius: 20,
                  padding: 16,
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 12,
                    marginBottom: 10,
                  }}
                >
                  <span
                    style={{
                      fontSize: 13,
                      color: "rgba(255,248,239,0.72)",
                      fontWeight: 600,
                    }}
                  >
                    {done ? "Supabase sports ready" : "Scanning sport locations"}
                  </span>

                  <span
                    style={{
                      fontFamily: "'Sora', sans-serif",
                      fontSize: 16,
                      fontWeight: 800,
                      color: "#fff8ef",
                    }}
                  >
                    {pct}%
                  </span>
                </div>

                <div
                  style={{
                    height: 8,
                    borderRadius: 999,
                    background: "rgba(255,255,255,0.08)",
                    overflow: "hidden",
                    marginBottom: 16,
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: `${pct}%`,
                      borderRadius: 999,
                      transition: "width 0.6s ease",
                      background:
                        "linear-gradient(90deg, #0B6E4F 0%, #fff8ef 50%, #C1121F 100%)",
                      boxShadow: "0 0 16px rgba(255,255,255,0.18)",
                    }}
                  />
                </div>

                <div
                  className="city-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: 8,
                  }}
                >
                  {CITIES.map((city, i) => (
                    <div
                      key={city}
                      className={`city-chip${cityStates[i] ? ` ${cityStates[i]}` : ""}`}
                    >
                      {city}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}